/**
 * Recharts can't read CSS variables directly, so chart strokes/fills are
 * resolved to the same hex/hsl values that the design tokens declare in
 * index.css. Keep these in lockstep — if you change a token, change here too.
 */

export const CHART_COLORS = {
  brand: "#0994f2", // --cinch-brand
  power: "#2851d0", // --cinch-power
  success: "hsl(152 60% 36%)", // --status-success
  warning: "hsl(38 92% 50%)", // --status-warning
  danger: "hsl(0 84% 60%)", // --status-danger
  info: "#0994f2", // --status-info (matches brand)
  muted: "hsl(0 0% 80%)",
  border: "hsl(0 0% 90%)",
  gridLine: "hsl(0 0% 88%)",
  background: "hsl(0 0% 100%)", // --background — halo stroke around chart dots
} as const;

/** Billing-status mix donut palette — soft tints so the donut stays
 *  readable next to KPI text. */
export const STATUS_MIX_COLOR: Record<string, string> = {
  Active: "#6fd49a",
  "At Risk": "#f0d18a",
  "Midterm Churn": "#f0bda0",
  Churned: "#ddb0b0",
  "Booked Not Billed": "#b0c7e8",
};

/** Donut wedge color for statuses missing from the map above. */
export const STATUS_MIX_FALLBACK = "#cfccc4";
